module.exports = __webpack_public_path__ + "img/lobby_nav.7a6bac16.svg";